// 格式化时间
function formatTime(date, format = null) {
  var daDate = new Date(date * 1000),
      // 毫秒级
  formatsArr = ['Y', 'M', 'D', 'h', 'i', 's'],
      returnArr = [],
      year = daDate.getFullYear(),
      month = daDate.getMonth() + 1,
      day = daDate.getDate(),
      hour = daDate.getHours(),
      minute = daDate.getMinutes(),
      second = daDate.getSeconds();

  function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
  }

  if (format === null) {
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':');
  } else {
    returnArr.push(year);
    returnArr.push(formatNumber(month));
    returnArr.push(formatNumber(day));
    returnArr.push(formatNumber(hour));
    returnArr.push(formatNumber(minute));
    returnArr.push(formatNumber(second));

    for (let i in returnArr) {
      format = format.replace(formatsArr[i], returnArr[i]);
    }

    return format;
  }
} 

// AJAX 请求
// function request(url, method = 'GET', data = {}) {
//   let header = {
//     'content-type': 'application/json',
//     'X-ECAPI-Sign': '',
//     'X-ECAPI-UDID': '',
//     'X-ECAPI-UserAgent': 'Platform/Wechat',
//     'X-ECAPI-Ver': '1.1.0'
//   };
//   let token = uni.getStorageSync('api_token') || '';
//   if (token) {
//     header['X-ECAPI-Authorization'] = token;
//   }
//   return new Promise(function (resolve, reject) {
   
//   });
// } 

// 复制信息
function copyMessage(data){
  return new Promise((resolve,reject)=>{
    // #ifdef H5
    let result
    let textarea = document.createElement('textarea')
    textarea.value = data
    textarea.readOnly = "readOnly"
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0,data.length)
    resolve({})
    result = document.execCommand("copy")
    textarea.remove()
    // #endif
  })


}

function getUserInfo(){
  let plat = getAppPlat()
  //此时先清空保存的token信息
  if(plat === 'ios'){
    return new Promise((resolve,reject)=>{
      // resolve();return;
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getUserInfo','', responseData=>{
          let result = JSON.parse(responseData)
          if(result.token){
            resolve(result.token)
          }else {
            reject()
          }
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getUserInfo();
        result?resolve(result.getToken()):reject()
      }
    })
  }
}

function getAppMallToken(){
  let plat = getAppPlat()
  //此时先清空保存的token信息

  if(plat === 'ios'){
    return new Promise((resolve,reject)=>{
      // resolve();return;
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getUSMallToken','', responseData=>{
          let result = JSON.parse(responseData)
          if(result.token){
            resolve(result.token)
          }else {
            reject()
          }
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getUSMallToken();
        result?resolve(result):reject()
      }
    })
  }
}

function hideAppTabBar(hide){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('hideTabbar',hide, responseData=>{
      })
    })
  }else {
    if(window.nativeBridge){
      if(hide){
        window.nativeBridge.hideTabBar();
      }else {
        window.nativeBridge.showTabBar();
      }

    }
  }
}

function setStatusBarHeight(height){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('setWebViewOriginY',height, responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        window.nativeBridge.setWebViewOriginY(height);
      }
    })
  }
}

function getAppCurrentMode(){
  let plat = getAppPlat()
  // uni.setStorageSync('userInfo',null)
  // uni.setStorageSync('api_token','');
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('isDarkMode','', responseData=>{
          responseData?resolve({plat:plat,isDark:true}):reject()
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.isDarkMode();
        result?resolve({plat:plat,isDark:true}):reject()
      }
    })
  }
}

function jumpToAppBindMoile(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('bindMobile','', responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.bindMobile();
        result?resolve(result):reject()
      }
    })
  }
}

function jumpToAppBindEmail(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('bindEmail','', responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.bindEmail();
        result?resolve(result):reject()
      }
    })
  }
}

function closeCurrentPage(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('closeCurrentPage','', responseData=>{
      })
    })
  }else {
    if(window.nativeBridge){
      let result = window.nativeBridge.closeCurrentPage();
    }
  }
}

function uploadImgByApp(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getSystemMedia','', responseData=>{
          responseData?resolve({responseData}):reject()
        })
        resolve()
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getSystemMedia();
        result?resolve(result):reject()
      }
    })
  }
}

/** App 版本号分段比较（如 4.66.00） */
function toAppVersionSegments(version) {
  var s = String(version != null ? version : '').trim();
  if (!s) return [0];
  return s.split('.').map(function (part) {
    var n = parseInt(part, 10);
    return isNaN(n) ? 0 : n;
  });
}

function compareAppVersion(a, b) {
  var aa = toAppVersionSegments(a);
  var bb = toAppVersionSegments(b);
  var len = Math.max(aa.length, bb.length);
  for (var i = 0; i < len; i++) {
    var x = aa[i] != null ? aa[i] : 0;
    var y = bb[i] != null ? bb[i] : 0;
    if (x < y) return -1;
    if (x > y) return 1;
  }
  return 0;
}

/** 同步：current 是否不低于 minVersion */
function isAppVersionAtLeast(current, minVersion) {
  return compareAppVersion(current, minVersion) >= 0;
}

function parseAppInfoPayload(responseData) {
  if (responseData == null) return null;
  if (typeof responseData === 'string') {
    try {
      return JSON.parse(responseData);
    } catch (e) {
      return null;
    }
  }
  return responseData;
}

/**
 * 对齐 store_sd_frontend/src/utils/JsBridge.js：注册 bridge.call 回调，走原生注入对象。
 * 仅初始化一次，供 getAppInfo 等异步 API 使用。
 */
var _bridgeCallMap = null;
var _bridgeNative = null;

function initBridgeCall() {
  if (_bridgeCallMap) return _bridgeNative;
  var ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (!/RR_MALL_(Android|IOS|Harmony)/i.test(ua)) return null;

  _bridgeNative = window.smartBridge;
  if (!_bridgeNative) return null;

  _bridgeCallMap = new Map();
  window._handleCallback = function (id, resultStr) {
    var fn = _bridgeCallMap.get(id);
    if (!fn) return;
    _bridgeCallMap.delete(id);
    var res;
    try {
      res = typeof resultStr === 'string' ? JSON.parse(resultStr) : resultStr;
    } catch (e) {
      fn(null, resultStr);
      return;
    }
    if (res && res.isSuccess) fn(res.result, null);
    else fn(null, (res && res.error) || 'bridge error');
  };
  return _bridgeNative;
}

/** 与 JsBridge.call 相同：bridge.call(name, params, callback) */
function bridgeCall(name, params, callback) {
  var bridge = initBridgeCall();
  if (!bridge || typeof bridge.call !== 'function') {
    callback(null, 'NOT_SUPPORT');
    return;
  }
  var isSupport =
    typeof bridge.isSupportProtocol === 'function'
      ? bridge.isSupportProtocol(name)
      : false;
  if (!isSupport) {
    callback(null, 'NOT_SUPPORT');
    return;
  }
  var realParams = params != null ? JSON.stringify(params) : null;
  var id = Date.now() + '_' + Math.random().toString(36).slice(2);
  _bridgeCallMap.set(id, callback);
  bridge.call(name, realParams, id);
}

function getAppInfoLegacy() {
  var plat = getAppPlat();
  if (plat === 'ios') {
    return new Promise(function (resolve, reject) {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('getAppInfo', '', function (responseData) {
          var result = parseAppInfoPayload(responseData);
          result ? resolve(result) : reject(new Error('getAppInfo empty'));
        });
      });
    });
  }
  return new Promise(function (resolve, reject) {
    if (!window.nativeBridge || typeof window.nativeBridge.getAppInfo !== 'function') {
      reject(new Error('NOT_SUPPORT'));
      return;
    }
    try {
      var raw = window.nativeBridge.getAppInfo();
      var result = parseAppInfoPayload(raw);
      result ? resolve(result) : reject(new Error('getAppInfo empty'));
    } catch (e) {
      reject(e);
    }
  });
}

function getAppInfo() {
  return new Promise(function (resolve, reject) {
    bridgeCall('getAppInfo', null, function (res, error) {
      if (error) {
        getAppInfoLegacy().then(resolve).catch(reject);
        return;
      }
      var parsed = parseAppInfoPayload(res);
      parsed ? resolve(parsed) : reject(new Error('getAppInfo empty'));
    });
  });
}

function getAppVersion() {
  return getAppInfo()
    .then(function (info) {
      return info && info.app_version != null ? info.app_version : null;
    })
    .catch(function () {
      return null;
    });
}

/** 异步：当前 App 版本是否不低于 minVersion */
function isAppVersionAtLeastAsync(minVersion) {
  return getAppVersion().then(function (v) {
    // return true; // 测试代码：永远返回 true
    if (v == null) return false;
    return isAppVersionAtLeast(v, minVersion);
  });
}

/** @returns {'ios'|'android'|'harmony'} ios 用 Bridge；android/harmony 用 nativeBridge */
function getAppPlat() {
  var nav = typeof navigator !== 'undefined' ? navigator : null;
  var ua = (nav && nav.userAgent) || '';

  if (/RR_MALL_IOS/i.test(ua)) return 'ios';
  if (/RR_MALL_Harmony/i.test(ua)) return 'harmony';
  if (/RR_MALL_Android/i.test(ua)) return 'android';

  if (/iPhone|iPod|iPad/i.test(ua)) return 'ios';
  if (nav && /Macintosh/i.test(ua) && nav.maxTouchPoints > 1) return 'ios';
  return 'android';
}

function checkAppPayIsInstalled(payMethod){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge => {
        if (payMethod === 'weixin') {
          //检测微信是否安装
          bridge.callHandler('isWXAppInstalled', '', responseData => {
            responseData?resolve(true):resolve(false)
          })
        } else {
          //检测支付宝是否安装
          bridge.callHandler('isAliPayAppInstalled', '', responseData => {
            responseData?resolve(true):resolve(false)
          })
        }
      })
    })
  }else {
    if(window.nativeBridge){
      return new Promise((resolve,reject)=> {
        if (payMethod === 'weixin') {
          //检测微信是否安装
          let result = window.nativeBridge.isWXAppInstalled();
          result?resolve(true):resolve(false)
        } else {
          //检测支付宝是否安装
          let result = window.nativeBridge.isAliPayAppInstalled();
          result?resolve(true):resolve(false)
        }
      })
    }
  }
}

function setupWebViewJavascriptBridge(callback){
  if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge); }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
}

function getStatusBarHeight(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getStatusBarHeight','', responseData=>{
          responseData != null && responseData !== '' ? resolve(responseData) : reject()
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge && typeof window.nativeBridge.getStatusBarHeight === 'function'){
        let result = window.nativeBridge.getStatusBarHeight();
        result != null ? resolve(result) : reject()
      }else {
        reject()
      }
    })
  }
}

function showAppTabBar(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('showTabbar','', responseData=>{})
    })
  }else {
    if(window.nativeBridge && typeof window.nativeBridge.showTabBar === 'function'){
      window.nativeBridge.showTabBar();
    }
  }
}

function callClipboard(text){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('callClipboard', text != null ? text : '', responseData=>{
          resolve(responseData)
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge && typeof window.nativeBridge.callClipboard === 'function'){
        let result = text != null ? window.nativeBridge.callClipboard(text) : window.nativeBridge.callClipboard();
        resolve(result)
      }else {
        reject()
      }
    })
  }
}

function callNativeStatistics(params){
  let plat = getAppPlat()
  let payload = params != null ? params : ''
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('callNativeStatistics', payload, responseData=>{
          resolve(responseData)
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge && typeof window.nativeBridge.callNativeStatistics === 'function'){
        let result = payload !== '' ? window.nativeBridge.callNativeStatistics(payload) : window.nativeBridge.callNativeStatistics();
        resolve(result)
      }else {
        reject()
      }
    })
  }
}

function hasHandler(handlerName){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('hasHandler', handlerName != null ? handlerName : '', responseData=>{
          resolve(responseData)
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge && typeof window.nativeBridge.hasHandler === 'function'){
        let result = window.nativeBridge.hasHandler(handlerName);
        resolve(result)
      }else {
        reject()
      }
    })
  }
}

function openHelpAndFeedback(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('openHelpAndFeedback','', responseData=>{})
    })
  }else {
    if(window.nativeBridge && typeof window.nativeBridge.openHelpAndFeedback === 'function'){
      window.nativeBridge.openHelpAndFeedback();
    }
  }
}

function openProfilePage(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('openProfilePage','', responseData=>{})
    })
  }else {
    if(window.nativeBridge && typeof window.nativeBridge.openProfilePage === 'function'){
      window.nativeBridge.openProfilePage();
    }
  }
}

function openSettingPage(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('openSettingPage','', responseData=>{})
    })
  }else {
    if(window.nativeBridge && typeof window.nativeBridge.openSettingPage === 'function'){
      window.nativeBridge.openSettingPage();
    }
  }
}

function statCommonData(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('statCommonData','', responseData=>{
          let result = parseAppInfoPayload(responseData);
          result != null ? resolve(result) : resolve(responseData)
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge && typeof window.nativeBridge.statCommonData === 'function'){
        let raw = window.nativeBridge.statCommonData();
        let result = parseAppInfoPayload(raw);
        result != null ? resolve(result) : resolve(raw)
      }else {
        reject()
      }
    })
  }
}

// UA 判定：window.__rrMallIsAppWebView__ 由 assets/rr-mall-app-detect.js 挂载（layout head 引入）。

// function setCookie(name,value,domain,exdays=1){
//   let exdate = new Date()
//   exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
//   window.document.cookie = name + '=' + encodeURIComponent (value) + ';path=/;expires=' + exdate.toGMTString() + ';domain=.roborock.com'
// }



// App-JSBridge.js loaded nativeBridge {
//   "callClipboard": function(), 
//   "callNativeStatistics": function(), 
//   "closeCurrentPage": function(), 
//   "getAppInfo": function(), 
//   "getStatusBarHeight": function(), 
//   "getUSMallToken": function(), 
//   "getUserInfo": function(), 
//   "hasHandler": function(), 
//   "hideTabBar": function(), 
//   "isDarkMode": function(), 
//   "openHelpAndFeedback": function(), 
//   "openProfilePage": function(), 
//   "openSettingPage": function(), 
//   "setWebViewOriginY": function(), 
//   "showTabBar": function(), 
//   "statCommonData": function()
// }
